import React, { useState } from 'react';

interface ProductNavBarProps {
  activeProduct: string;
  onProductChange: (product: string) => void;
  variant?: 'default' | 'dropdown';
}

const ProductNavBar: React.FC<ProductNavBarProps> = ({
  activeProduct,
  onProductChange,
  variant = 'default',
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const products = [
    'RFI Scanner',
    'Constellation Designer',
    'Space Scanner',
    'Astro-1',
    'AstroOrca',
    'AstroLibrary',
    'Abacus',
  ];

  if (variant === 'dropdown') {
    return (
      <div className='relative w-full md:w-[200px]'>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className='flex items-center gap-2 text-[14px] h-fit w-full font-medium text-[#C6C6C6] hover:text-[#fccb15]/80 transition-colors duration-200 border justify-between border-[#5C5C5C] rounded-md pl-3 pr-2 py-2'
        >
          {activeProduct}
          <svg
            className={`w-4 h-4 transition-transform duration-200 ${
              isDropdownOpen ? 'rotate-180' : ''
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {isDropdownOpen && (
          <div className='absolute top-full right-0 mt-2 bg-[#1a1a1a] border border-[#333] rounded-lg shadow-lg z-50 min-w-full md:min-w-[200px]'>
            {products.map((product, index) => (
              <button
                key={index}
                onClick={() => {
                  onProductChange(product);
                  setIsDropdownOpen(false);
                }}
                className={`w-full text-left px-4 py-3 text-sm font-medium transition-colors duration-200 hover:bg-[#333] hover:text-[#fccb15] first:rounded-t-lg last:rounded-b-lg ${
                  activeProduct === product
                    ? 'text-[#fccb15] bg-[#333]'
                    : 'text-[#a7a7a7]'
                }`}
              >
                {product}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <nav className='w-full md:max-w-[600px] xl:max-w-[1280px] mx-auto flex flex-row justify-between xl:justify-start items-center py-3'>
      <div className='gap-8 xl:gap-12 flex flex-wrap items-center justify-center w-full xl:w-auto'>
        {products.map((product, index) => (
          <button
            key={index}
            onClick={() => onProductChange(product)}
            className={`text-sm md:text-lg font-medium transition-colors duration-200 hover:text-[#fccb15] text-center ${
              activeProduct === product
                ? 'text-[#fccb15] underline'
                : 'text-[#a7a7a7]'
            }`}
          >
            {product}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default ProductNavBar;
